import React from 'react';

import ReportHeader from '../Components/ReportHeader';
import { ReportConfiguration } from '../types';
import { CategoryOverview } from './Components/CategoryOverview';
import { CategoryUsageBreakdown } from './Components/CategoryUsageBreakdown';
import { ApplicationOverlapReportData } from './types';

export interface ApplicationOverlapReportProps {
    reportData: ApplicationOverlapReportData;
    renderingScheduledReport: boolean;
    reportSetup: ReportConfiguration;
}
export const ApplicationOverlapReport = ({
    reportData,
    renderingScheduledReport,
    reportSetup
}: ApplicationOverlapReportProps) => {
    const { startTime, endTime, type } = reportSetup;

    return (
        <>
            <ReportHeader
                startDate={startTime}
                endDate={endTime}
                reportType={type}
            />
            {reportData.applicationOverlapApplicationOverlapCategoryOverview && (
                <CategoryOverview
                    renderingScheduledReport={renderingScheduledReport}
                    categoryData={
                        reportData.applicationOverlapApplicationOverlapCategoryOverview
                    }
                />
            )}

            {reportData.applicationOverlapApplicationOverlapCategoryBreakdown && (
                <CategoryUsageBreakdown
                    categoryUsageBreakdownData={
                        reportData.applicationOverlapApplicationOverlapCategoryBreakdown
                    }
                />
            )}
        </>
    );
};
